import { render, staticRenderFns } from "./GlucoseLevel.vue?vue&type=template&id=25c0dd12&scoped=true"
import script from "./GlucoseLevel.vue?vue&type=script&lang=js"
export * from "./GlucoseLevel.vue?vue&type=script&lang=js"
import style0 from "./GlucoseLevel.vue?vue&type=style&index=0&id=25c0dd12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c0dd12",
  null
  
)

export default component.exports